/* TAPS shared motion layer — scroll reveals, header state, mini-CTA, FAQ, active-nav.
   Opt-in via classes (.reveal, .taps-header, .taps-mini-cta, details.taps-faq). Safe site-wide. */
(function () {
  var reduced = matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* mobile nav drawer toggle */
  var navToggle = document.querySelector('[data-taps-nav-toggle]');
  var navHeader = document.querySelector('.taps-header');
  if (navToggle && navHeader) {
    function closeNav() {
      if (!navHeader.classList.contains('nav-open')) return;
      navHeader.classList.remove('nav-open');
      navToggle.setAttribute('aria-expanded', 'false');
    }
    function openNav() {
      navHeader.classList.add('nav-open');
      navToggle.setAttribute('aria-expanded', 'true');
      // move focus to first nav link for keyboard users
      var first = navHeader.querySelector('.taps-nav .taps-nav__link');
      if (first) { try { first.focus({ preventScroll: true }); } catch (e) { first.focus(); } }
    }
    navToggle.addEventListener('click', function () {
      if (navHeader.classList.contains('nav-open')) closeNav();
      else openNav();
    });
    /* close on Escape, return focus to toggle */
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && navHeader.classList.contains('nav-open')) {
        closeNav();
        try { navToggle.focus({ preventScroll: true }); } catch (err) { navToggle.focus(); }
      }
    });
    navHeader.querySelectorAll('.taps-nav__link').forEach(function (l) {
      l.addEventListener('click', closeNav);
    });
  }

  /* scroll progress (skip entirely under reduced-motion) */
  var fill = document.querySelector('.taps-progress > div');
  if (fill && !reduced) {
    var pRaf = null;
    function prog() { pRaf = null; var max = document.documentElement.scrollHeight - window.innerHeight; fill.style.transform = 'scaleX(' + (max > 0 ? Math.min(1, Math.max(0, window.scrollY / max)) : 0) + ')'; }
    addEventListener('scroll', function () { if (!pRaf) pRaf = requestAnimationFrame(prog); }, { passive: true });
    addEventListener('resize', function () { if (!pRaf) pRaf = requestAnimationFrame(prog); }, { passive: true });
    prog();
  }

  /* sticky header state */
  var header = document.querySelector('.taps-header');
  if (header) {
    var hRaf = null;
    function hdr() { hRaf = null; header.classList.toggle('is-scrolled', window.scrollY > 12); }
    addEventListener('scroll', function () { if (!hRaf) hRaf = requestAnimationFrame(hdr); }, { passive: true });
    hdr();
  }

  /* auto scroll-reveal: EVERY content section slides up on scroll, site-wide.
     The hero (first section) is skipped — it has its own word-stagger animation.
     Sections with inner .reveal items keep their per-card stagger on top. */
  var contentSections = document.querySelectorAll('#MainContent .shopify-section');
  contentSections.forEach(function (s, idx) {
    if (idx === 0) return;                 // leave hero to its own intro animation
    s.classList.add('reveal');             // whole-section slide-up
  });

  /* scroll reveals (single observer, fire once) */
  var reveals = document.querySelectorAll('.reveal, .reveal--scale, .reveal--accent-bar');
  if (reveals.length && 'IntersectionObserver' in window) {
    var ro = new IntersectionObserver(function (es) {
      es.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('is-in', 'is-visible'); ro.unobserve(e.target); } });
    }, { threshold: 0.15, rootMargin: '0px 0px -8% 0px' });
    reveals.forEach(function (el) { ro.observe(el); });
  } else if (reveals.length) {
    /* no IntersectionObserver: never let .reveal be the sole reason content is hidden */
    reveals.forEach(function (el) { el.classList.add('is-in', 'is-visible'); });
  }

  /* sticky mini-CTA — show after hero scrolls out */
  var mini = document.querySelector('.taps-mini-cta');
  if (mini) {
    var anchor = document.querySelector('[data-taps-hero]') || document.querySelector('.taps-hero');
    var dismissed = false;
    try { dismissed = sessionStorage.getItem('taps-cta-dismissed') === '1'; } catch (e) {}
    if (dismissed) { mini.style.display = 'none'; }
    else {
      var mRaf = null;
      /* show the floating Enroll button as soon as the visitor starts scrolling
         (past ~240px / the fold), then it stays fixed in place the whole way down.
         Bound unconditionally so it never depends on a hero sentinel. */
      function upd() { mRaf = null; mini.classList.toggle('is-shown', window.scrollY > 240); }
      addEventListener('scroll', function () { if (!mRaf) mRaf = requestAnimationFrame(upd); }, { passive: true });
      upd();
    }
    var close = mini.querySelector('.taps-mini-cta__close');
    if (close) close.addEventListener('click', function () {
      try { sessionStorage.setItem('taps-cta-dismissed', '1'); } catch (e) {}
      mini.classList.remove('is-shown');
      setTimeout(function () { mini.style.display = 'none'; }, 500);
    });
  }

  /* FAQ accordion smooth height */
  document.querySelectorAll('details.taps-faq').forEach(function (d) {
    var sum = d.querySelector('summary'), body = d.querySelector('.taps-faq__a');
    if (!sum || !body) return;
    if (!d.open) { body.style.maxHeight = '0px'; body.style.opacity = '0'; }
    sum.addEventListener('click', function (e) {
      e.preventDefault();
      if (reduced) { d.open = !d.open; body.style.maxHeight = d.open ? 'none' : '0px'; body.style.opacity = d.open ? '1' : '0'; return; }
      if (d.open) {
        body.style.maxHeight = body.scrollHeight + 'px';
        requestAnimationFrame(function () { requestAnimationFrame(function () { body.style.maxHeight = '0px'; body.style.opacity = '0'; }); });
        setTimeout(function () { d.open = false; }, 420);
      } else {
        d.open = true; body.style.maxHeight = '0px'; body.style.opacity = '0';
        var h = body.scrollHeight;
        requestAnimationFrame(function () { requestAnimationFrame(function () { body.style.maxHeight = h + 'px'; body.style.opacity = '1'; }); });
        setTimeout(function () { if (d.open) body.style.maxHeight = 'none'; }, 440);
      }
    });
  });

  /* aria-current="page" on the nav link matching the current pathname (WCAG 1.3.1) */
  try {
    var pathnow = location.pathname.replace(/\/+$/, '') || '/';
    document.querySelectorAll('.taps-nav__link').forEach(function (l) {
      var hrefAttr = l.getAttribute('href') || '';
      // strip hash + querystring for the comparison
      var hrefPath = hrefAttr.split('#')[0].split('?')[0].replace(/\/+$/, '') || '/';
      if (hrefPath && hrefPath === pathnow) l.setAttribute('aria-current', 'page');
    });
  } catch (e) {}

  /* active-section nav underline */
  var links = document.querySelectorAll('.taps-nav__link');
  var map = {};
  links.forEach(function (l) { var h = l.getAttribute('href') || ''; var i = h.indexOf('#'); if (i >= 0 && h.length > i + 1) map[h.slice(i + 1)] = l; });
  var ids = Object.keys(map);
  if (ids.length && 'IntersectionObserver' in window) {
    var vis = {};
    var no = new IntersectionObserver(function (es) {
      es.forEach(function (e) { vis[e.target.id] = e.intersectionRatio; });
      var best = null, br = 0; for (var k in vis) if (vis[k] > br) { br = vis[k]; best = k; }
      links.forEach(function (l) { l.classList.remove('is-active'); });
      if (best && br > 0.1 && map[best]) map[best].classList.add('is-active');
    }, { threshold: [0, 0.25, 0.5, 0.75, 1] });
    ids.forEach(function (id) { var el = document.getElementById(id); if (el) no.observe(el); });
  }

  /* hero word-stagger + accent underline draw */
  var heroTitle = document.querySelector('.taps-hero__title');
  if (heroTitle && !reduced) {
    function splitWords(host) {
      var out = [];
      Array.prototype.slice.call(host.childNodes).forEach(function (child) {
        if (child.nodeType === 3) {
          child.textContent.split(/(\s+)/).forEach(function (part) {
            if (!part) return;
            if (/^\s+$/.test(part)) { out.push(document.createTextNode(part)); return; }
            var w = document.createElement('span'); w.className = 'taps-word';
            var inner = document.createElement('span'); inner.className = 'taps-word-inner';
            inner.textContent = part; w.appendChild(inner); out.push(w);
          });
        } else if (child.nodeType === 1) {
          if (child.classList && child.classList.contains('taps-accent-text')) {
            var inside = splitWords(child); child.innerHTML = '';
            inside.forEach(function (n) { child.appendChild(n); }); out.push(child);
          } else { out.push(child); }
        }
      });
      return out;
    }
    var nodes = splitWords(heroTitle);
    heroTitle.innerHTML = '';
    nodes.forEach(function (n) { heroTitle.appendChild(n); });
    var words = heroTitle.querySelectorAll('.taps-word-inner');
    words.forEach(function (w, i) { w.style.transitionDelay = (i * 60) + 'ms'; });
    requestAnimationFrame(function () { requestAnimationFrame(function () { heroTitle.classList.add('is-words-in'); }); });
    setTimeout(function () {
      var acc = heroTitle.querySelector('.taps-accent-text');
      if (acc) acc.classList.add('is-drawn');
    }, words.length * 60 + 120);
  } else if (heroTitle) {
    var acc = heroTitle.querySelector('.taps-accent-text'); if (acc) acc.classList.add('is-drawn');
  }

  /* mentor photo 3D tilt (desktop, fine pointer) */
  var photo = document.querySelector('.taps-mentor__photo');
  if (photo && !reduced && matchMedia('(hover: hover)').matches) {
    var tx = 0, ty = 0, cx = 0, cy = 0, raf = null;
    function tilt() {
      cx += (tx - cx) * 0.12; cy += (ty - cy) * 0.12;
      photo.style.transform = 'perspective(800px) rotateX(' + cy.toFixed(2) + 'deg) rotateY(' + cx.toFixed(2) + 'deg)';
      if (Math.abs(tx - cx) > 0.01 || Math.abs(ty - cy) > 0.01) raf = requestAnimationFrame(tilt);
      else { raf = null; if (tx === 0 && ty === 0) photo.style.transform = ''; }
    }
    photo.addEventListener('mousemove', function (e) {
      var r = photo.getBoundingClientRect();
      tx = ((e.clientX - r.left) / r.width - 0.5) * 12;
      ty = -((e.clientY - r.top) / r.height - 0.5) * 12;
      if (!raf) raf = requestAnimationFrame(tilt);
    });
    photo.addEventListener('mouseleave', function () { tx = 0; ty = 0; if (!raf) raf = requestAnimationFrame(tilt); });
  }

  /* hero mesh parallax — drift the whole mesh layer on scroll (blobs keep their float anim) */
  var mesh = document.querySelector('.tshero__mesh');
  if (mesh && !reduced) {
    var meshRaf = null;
    function par() { meshRaf = null; mesh.style.transform = 'translate3d(0,' + (window.scrollY * 0.22).toFixed(1) + 'px,0)'; }
    addEventListener('scroll', function () { if (!meshRaf) meshRaf = requestAnimationFrame(par); }, { passive: true });
    par();
  }
})();
